/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlErrorCode = {
    MissingField: 'MISSING_FIELD',
    ExistingAccountMs365: 'EXISTING_ACCOUNT_MS365',
    ExistingAccountGoogle: 'EXISTING_ACCOUNT_GOOGLE',
    SsoLoginNoTokens: 'SSO_LOGIN_NO_TOKENS',
    SsoLoginMissingClaims: 'SSO_LOGIN_MISSING_CLAIMS',
    SsoLoginUserNotFound: 'SSO_LOGIN_USER_NOT_FOUND',
    SsoLoginMismatch: 'SSO_LOGIN_MISMATCH',
    SsoLoginFailed: 'SSO_LOGIN_FAILED',
    SsoConfirmationTokenError: 'SSO_CONFIRMATION_TOKEN_ERROR',
    SsoConfirmMissingRole: 'SSO_CONFIRM_MISSING_ROLE',
    SsoConfirmMissingEmail: 'SSO_CONFIRM_MISSING_EMAIL',
    SsoConfirmMismatch: 'SSO_CONFIRM_MISMATCH',
    SsoConfirmFailedTokenRefresh: 'SSO_CONFIRM_FAILED_TOKEN_REFRESH',
    SsoConfirmTokenExpired: 'SSO_CONFIRM_TOKEN_EXPIRED',
    SsoConfirmTokenError: 'SSO_CONFIRM_TOKEN_ERROR',
    SsoConfirmFailedLink: 'SSO_CONFIRM_FAILED_LINK',
    SsoErrorUpdatingUser: 'SSO_ERROR_UPDATING_USER',
    DeletedUserSignup: 'DELETED_USER_SIGNUP',
    ClientIdMissing: 'CLIENT_ID_MISSING',
    MissingOrInvalidClientRole: 'MISSING_OR_INVALID_CLIENT_ROLE',
    FailToGetBeToken: 'FAIL_TO_GET_BE_TOKEN',
    AsmApiError: 'ASM_API_ERROR',
    DisabledContactWithoutExistingContact: 'DISABLED_CONTACT_WITHOUT_EXISTING_CONTACT',
    ResolutionRequestNotFound: 'RESOLUTION_REQUEST_NOT_FOUND'
} as const;
export type ControlErrorCode = typeof ControlErrorCode[keyof typeof ControlErrorCode];


export function ControlErrorCodeFromJSON(json: any): ControlErrorCode {
    return ControlErrorCodeFromJSONTyped(json, false);
}

export function ControlErrorCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlErrorCode {
    return json as ControlErrorCode;
}

export function ControlErrorCodeToJSON(value?: ControlErrorCode | null): any {
    return value as any;
}

